var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _clipPath, _clipPath2, _clipPath3, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _circle2, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g2, _g3, _g4, _path84, _path85, _ellipse, _path86, _path87, _path88, _path89, _g5, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg62(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 935.2 695.8",
    viewBox: "0 0 935.2 695.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93fd93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84f599"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1625.6091,
    x2: 1707.9948,
    xlinkHref: "#a",
    y1: -918.1061,
    y2: -918.1061
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1656.4784,
    x2: 1703.2897,
    xlinkHref: "#a",
    y1: -892.0875,
    y2: -949.4793
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1710.3809,
    x2: 1774.7371,
    xlinkHref: "#a",
    y1: -956.9851,
    y2: -907.1899
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1726.5596,
    x2: 1671.2838,
    xlinkHref: "#a",
    y1: -931.696,
    y2: -861.72
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1671.984,
    x2: 1710.8754,
    xlinkHref: "#a",
    y1: -888.3323,
    y2: -888.3323
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1707.5419,
    x2: 1749.6709,
    xlinkHref: "#a",
    y1: -951.8732,
    y2: -890.9457
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1 0 0 -1 -858.14 -351.79)",
    gradientUnits: "userSpaceOnUse",
    x1: 1683.2542,
    x2: 1743.2793,
    y1: -967.6188,
    y2: -967.6188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006880928,
    stopColor: "#58caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#4b45bd"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 192.4434,
    x2: 289.2537,
    y1: 458.026,
    y2: 458.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f68ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aceed"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 169.999,
    x2: 301.4193,
    y1: 237.2402,
    y2: 237.2402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f87b58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f89453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f8c548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c51"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 164.787,
    x2: 303.6986,
    y1: 284.1531,
    y2: 284.1531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1a1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7658f4"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 216.5845,
    x2: 262.8274,
    y1: 151.9377,
    y2: 151.9377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5aceed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4f68ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282d3"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.7 190.5h14.8v24.2h-14.8z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.7 235.3h41.2v71.5h-41.2z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.9 345.2h33.6v255.6h-33.6z"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 526.8295,
    x2: 624.3043,
    y1: 323.6448,
    y2: 323.6448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd94ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5df5"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 480.8087,
    x2: 528.2347,
    y1: 352.2873,
    y2: 352.2873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8260f4"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 526.8562,
    x2: 624.3309,
    y1: 322.8863,
    y2: 322.8863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8260f4"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4cbf"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 679.7956,
    x2: 690.8999,
    xlinkHref: "#s",
    y1: 340.1604,
    y2: 340.1604
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientTransform: "matrix(.9997 -.02303631 .02303631 .9997 -797.7697 -881.6936)",
    gradientUnits: "userSpaceOnUse",
    x1: 1480.5219,
    x2: 1486.6023,
    xlinkHref: "#s",
    y1: 1260.1307,
    y2: 1260.1307
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 685.6432,
    x2: 725.9604,
    y1: 328.3814,
    y2: 328.3814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c4fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58caea"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d54c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4cbf"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 696.2399,
    x2: 699.5172,
    xlinkHref: "#w",
    y1: 323.6005,
    y2: 323.6005
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 714.6634,
    x2: 717.496,
    xlinkHref: "#w",
    y1: 323.6454,
    y2: 323.6454
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b46bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cd4ee"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 500.2596,
    x2: 544.719,
    xlinkHref: "#z",
    y1: 185.2048,
    y2: 185.2048
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d5df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd94ef"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 501.8246,
    x2: 547.2562,
    xlinkHref: "#B",
    y1: 190.6229,
    y2: 190.6229
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 544.0267,
    x2: 568.8185,
    xlinkHref: "#z",
    y1: 187.6865,
    y2: 156.7535
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 476.567,
    x2: 501.3587,
    xlinkHref: "#z",
    y1: 187.4494,
    y2: 156.5164
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientTransform: "matrix(.7881 -.455 .37 .6409 -648.9563 73.0098)",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.6259,
    x2: 1114.8467,
    xlinkHref: "#z",
    y1: 963.2016,
    y2: 934.2283
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 551.2473,
    x2: 572.8083,
    xlinkHref: "#B",
    y1: 188.7832,
    y2: 161.8812
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 482.9966,
    x2: 506.981,
    xlinkHref: "#B",
    y1: 187.7244,
    y2: 157.7991
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.3 307.9s-80.3-258.3 139.1-271.3 178.9 55.3 373.7 13.1 198.1-71.3 299.5-29.2 108 150.7 86.8 205.9-63.8 98.9-60.6 129.7 72.1 110 81.2 163.5c5 29.2-9.5 79-23.1 81.1-100.9 16.1-506.2-10.4-506.2-10.4l-235.3-10.4-125.9-17.2s4.3-72.2 3.9-129.3c-.4-58.6-33.1-125.5-33.1-125.5z",
    fill: "#f8f8ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44 554.8s-27.4 113.4 123.1 105.7 148.8-24.4 243.8 5.1 154.2 41.2 227.6 18 75.3-19.3 168.5-19.3 125.1-99.4 127.5-113c2.9-16-3.8-68.5-17.2-68.6-98.5-1.2-708.6-6.3-756.7 7-41.3 11.4-91 49.4-114.9 59.5",
    fill: "#f5f5fc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m62 455.2 93-38 1.6-380.4s-68.6 4.4-95.6 30.4z",
    fill: "#e9edfb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m61 67.2 2.3 387.5-16.3 6.8s2.3-17.6-1.7-55.9c-3.7-35.7-41.5-122.3-44.3-155.4-2-23.5-.9-119.2 22.5-147.6 21.6-26.1 37.5-35.4 37.5-35.4z",
    fill: "#e9edfb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.5,
    cy: 166.8,
    rx: 19.5,
    ry: 13.5,
    transform: "matrix(.9852 -.1716 .1716 .9852 -27.0138 21.0838)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.6,
    cy: 162.7,
    rx: 15.9,
    ry: 11,
    transform: "matrix(.9852 -.1716 .1716 .9852 -25.9871 24.8161)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4,
    cy: 213.8,
    rx: 19.5,
    ry: 13.5,
    transform: "matrix(.9852 -.1716 .1716 .9852 -36.3823 6.6795)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6,
    cy: 203.7,
    rx: 15.9,
    ry: 11,
    transform: "matrix(.9852 -.1716 .1716 .9852 -34.3711 9.8089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.9 61 4.7-2.6.2-.1 2.9-1.5 2.8-1.3 4.7 390.5-9.8 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.1 357.2-1.1-3.7c-.2.1-.8-2.7-.9-2.7l-1.2-3-1.1-3.3 126.9-47.9.4 10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2 258.5-.4-2.1c-.2-.6-.5-3.1-.7-3.7l-.5-4.1-.5-3 156.5-59.8-.5 10.5z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m425.4 400.1c3.4-4.4 5.6-9.5 6.4-15 .9-6.7 3.3-15.1 9.4-20.9 9.3-8.8 10.6-46 10.8-59.8.1-5.2.9-10.4 2.4-15.3 2.8-8.7 8.4-20.8 19.4-26.6 11.2-5.9 47-8.4 57.4.3 21.2 17.7 18.3 41 18.6 44.7 1.6 17.4.6 30.1 9.5 41.1s18.9 24.3 16.3 37.8 20.7 33.5-4.8 41.8-51.6 14.1-80 11.8c-25.2-2-59.6-6.1-66.4-22.8-3.2-8.2-1.5-13.7 1-17.1z",
    fill: "#e9edfa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m431.8 398c1.2-1.7 2.7-4.2 5.4-5.6s8.2-5.2 35.1 5.8c38.4 15.8 70-3.5 73-3.9s30.1-8.9 29.4 8.9-32.8 27.4-42.5 27.8-50.1 4.2-70-1.5-27.5-13.4-28.9-15.3c-1.5-2.1-6.5-9.1-1.5-16.2z",
    fill: "#bac5f4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m434.4 527.2h1.9c3.4.1 6.3-2.7 6.3-6.1 0-.1 0-.1 0-.2l-.2-9c0-1-.7-1.9-1.6-2.3l-.6-.2c-1.3-.5-2-2-1.4-3.3.2-.5.5-.9.9-1.1.4-.3.9-.5 1.3-.7 4.2-1.6 13.1-6.7 36.5-9.1 12.8-1.3 19.3-1.7 22.7-1.8 1.4-.1 2.5-1.2 2.5-2.7 0-.2 0-.4-.1-.6-.3-1.2-1.5-2-2.8-1.8-8.2 1-37.4 4.5-47 6.8-5.6 1.4-11 3.7-16 6.7-1.9 1.2-3.2 3.2-3.4 5.5-.1.8-.5 1.5-1.1 1.9-1 .7-2 1.2-3.1 1.6-1.6.5-1.6 6-1.2 10.6.1 3.1 2.9 5.7 6.4 5.8z",
    fill: "#a2b7ed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m576.1 527.2h-1.4c-3.7.1-6.8-2.9-6.8-6.6 0-.1 0-.2 0-.3l.2-8.5c0-1 .6-1.9 1.6-2.3l.6-.2c1.3-.5 2-2 1.4-3.3-.2-.4-.5-.8-.9-1.1s-.9-.5-1.3-.7c-4.2-1.6-13-6.7-36.2-9.1-12.6-1.3-19.1-1.7-22.4-1.8-1.4-.1-2.5-1.2-2.5-2.7 0-.2 0-.4.1-.6.3-1.2 1.5-2 2.8-1.8 8.2 1 37.1 4.5 46.5 6.8 5.6 1.4 10.9 3.7 15.8 6.7 1.9 1.2 3.2 3.2 3.4 5.5.1.8.5 1.5 1.1 1.9.9.6 1.9 1.2 3 1.6 1.6.5 1.5 6.1 1.2 10.7-.1 3.1-2.8 5.7-6.2 5.8z",
    fill: "#a2b7ed"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m501.5 444.1-.2 75.7c0 1-.8 1.8-1.8 1.8h-.4c-1 0-1.8.8-1.8 1.8v.1l.3 12.8c.1 3.1 2.6 5.7 5.8 5.7l4 .1c3.3.1 6.1-2.6 6.1-5.9 0-.1 0-.2 0-.4l-.5-12.4c0-1-.8-1.7-1.8-1.7s-1.8-.8-1.8-1.8l.2-77.6c0-1-.8-1.8-1.8-1.8h-4.6c-1 0-1.8.8-1.8 1.8v.1z",
    fill: "#a2b7ed"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m501.6 499s-61.2 24.6-70.8 32.8-11.2 13.3-10.8 15.5c0 .2.4.4.8.5 2.4.7 4 2.9 3.9 5.3l-.2 12.9c0 2-1.7 3.6-3.6 3.6h-6.9c-2 0-3.6-1.6-3.7-3.6l-.2-12.8c-.1-2.7 1.9-5.1 4.6-5.5h.1s2.4-9.7 6.1-13 10.2-10.7 35.8-21.9 44.8-18.2 44.8-18.2z",
    fill: "#bac5f4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m509.3 498.1c0 .8.5 1.6 1.2 1.9 8.4 3.6 57.2 24.7 65.6 32.2 9.1 8.2 10.6 13.3 10.2 15.5-.1.5-1.4.7-2.7.8-1.1.1-1.9 1-1.9 2.1l.2 13.7c0 3.2 2.7 5.8 5.9 5.8h1.7c3.2 0 5.8-2.6 5.9-5.8l.2-13.6c0-1-.7-1.9-1.7-2l-1.5-.2c-.8-.1-1.4-.7-1.6-1.5-.7-2.7-2.7-9.2-5.5-11.8-3.5-3.3-9.7-10.7-33.9-21.9-18.6-8.5-33.5-14.6-39.4-17-1-.4-2.2 0-2.6 1 0 .3 0 .5-.1.8z",
    fill: "#bac5f4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m174 556.2 1-174h23v175z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m705 379.1 1 179.1h20l.4-178.3z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m104 361.2v21l688-2v-18z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m104 361.2 49-15 583 1 56 15z",
    fill: "#bac5f4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m416.5 355.4 11.5-7 53.1-.3-8 6.8z",
    fill: "#f8f8ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m152 309.1s-8.7-.4-9.8 2.4 2 41 3.4 43.3 15.2 2.9 19.1 2.9c0 0 14.5-1.3 15.2-2.3s10.5-40.5 7.3-45.8-34.7-.4-34.7-.4",
    fill: "#e9edfc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m141.5 318.1s27 2.1 30.2 1.2 2.1-9 2.1-9l13.4-.6s0 7.8-.9 8.7c-1 1.2-1.8 2.6-2.3 4.1 0 .5-5.7 33.5-5.7 33.5s-8.7 1.3-9.8 1.2c-1.4-.2 3.6-27.4 3.6-29.3s0-5.5-1.4-5.5-27.8.8-28-2.2c-.1-.7-.6-1.5-1.2-2.1",
    fill: "#bac4f6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m152.2 310s-7.5-5.3-11.5-5.8-8.7-1-12.7-1.6-9.1-2.4-9-4.8c.1-2.3.6-3.5 2.9-4.8 2-1.3 4.2-2.1 6.6-2.4 1.8-.2 19.8 4.5 27.3 15.7l3 3.7z",
    fill: "#bac4f6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m126.1 296.9s6.9-.1 10.7 1.1c3 1.1 5.8 2.4 8.6 4l11.3 7.9",
    fill: "#bac4f6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m126.1 296.9s6.9-.1 10.7 1.1c3 1.1 5.8 2.4 8.6 4l11.3 7.9",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m160.1 309.7s-8.8-11.9-12.2-15.2c-3.4-3.4-7.4-7.2-10.7-10.7s-7.4-8.5-5.7-10.6 3-3.5 6.2-3c2.5.3 4.9 1.2 7 2.6 1.8 1.1 17.7 16.3 20 33.7l2.3 3.5z",
    fill: "#bac4f6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m139.5 277.2s6.8 4.1 9.5 8c2.5 3.7 6.5 10.2 6.5 10.2l4.5 12.5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m164.5 310.2s-10.2-22.2-12.1-26.6-9.7-11-11.5-15.5c-1.7-4.5-2.8-7.7-1-10.2s6.5-4.5 9.5-3c2.8 1.4 6.5 5.6 8.1 7.7 1.2 1.7 9.6 31.8 8.9 38.8l1.6 8.9z",
    fill: "#e9edfc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m146.4 263.2s5.9 7.6 7.7 12c2 5 4 14.5 3.7 13l6.1 20.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m158.9 310.1s-9-10.3-13.4-12.3-9.4-4.2-13.7-6.4-9.4-5.8-8.6-8c.9-2.2 1.8-3.1 4.9-3.5 2.7-.5 5.5-.4 8.2.2 2 .5 20.8 11.9 25.6 25.4l2.2 4.7z",
    fill: "#e9edfc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m131.5 285.4s7.8 2.6 11.7 5.2c2.9 2.2 5.7 4.5 8.4 7.1l8.6 12.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m182.4 310.3s8.2-5 12.5-5.5 9.3-.9 13.7-1.5 9.8-2.3 9.7-4.5-.6-3.3-3.2-4.6c-2.2-1.2-4.6-2-7.1-2.3-1.9-.2-21.5 4.3-29.6 15l-3.3 3.5z",
    fill: "#bac4f6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m210.6 297.9s-7.5-.1-11.6 1.1c-3.2 1-6.3 2.3-9.3 3.8l-10.9 7.3",
    fill: "#bac4f6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m210.6 297.9s-7.5-.1-11.6 1.1c-3.2 1-6.3 2.3-9.3 3.8l-10.9 7.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m173.8 310.1s9.5-11.4 13.2-14.6 8-6.9 11.6-10.2 8-8.1 6.2-10.1-3.2-3.3-6.7-2.9c-2.7.2-5.2 1.1-7.5 2.5-1.9 1.1-19.1 15.6-21.6 32.2l-2.5 3.4z",
    fill: "#bac4f6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m196.1 279s-7.4 3.9-10.3 7.6c-2.7 3.5-7.1 9.8-7.1 9.8l-4.9 11.9",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m169.1 310.6s11.1-21.2 13.1-25.4 10.5-10.5 12.4-14.8 3.1-7.4 1.1-9.7-7.1-4.3-10.3-2.9c-3.1 1.3-7 5.3-8.8 7.4-1.4 1.6-10.4 30.4-9.7 37.1l-1.7 8.5z",
    fill: "#e9edfc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m168 310.3s.9-20.7 3-27.4c1.4-4.5 2.8-12 4.7-16.2s-1-9.8-2.9-12.2-7-1.9-10.3-.5c-3.1 1.3-4.8 5.6-5.2 7.9-.3 2.1 7 27 6.2 36.2l.6 12.4z",
    fill: "#bac4f6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m188.6 265.7s-6.3 7.2-8.3 11.5c-2.2 4.8-4.3 13.9-4 12.4l-7.2 20.2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m175.2 310.5s9.8-9.8 14.5-11.7 10.2-4 14.8-6.1 10.2-5.5 9.3-7.6-1.9-2.9-5.3-3.3c-2.9-.4-5.9-.4-8.8.2-2.2.5-22.5 11.3-27.7 24.2l-2.4 4.4z",
    fill: "#e9edfc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m204.7 286.8s-8.4 2.5-12.6 4.9c-3.1 2-6.2 4.3-9 6.7l-9.5 10.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m166 258.4s1.7 17.7.7 22.5c-.4 2-.2 14.5-.2 14.5l-.3 13.9",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m330.1 250.5h109.9v86.3h-109.9z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 382.7,
    cy: 294.3,
    fill: "#f5f5fc",
    r: 6.6
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m375.8 334.7s2.8 7.3-.4 9.3-22.6 9.7-22.6 9.7-1.4 2.3 2 3c3.1.7 42.5.1 51 0 1.2.1 2.3-.6 2.8-1.7.2-.7-.1-1.5-1.6-2-2.6-.9-12.2-6.2-16.4-8.4-1.5-.8-1.9-2.3-2.2-3.8-.5-2.3-.8-4.8.8-5.3 2.5-.8-13.3.2-13.3.2",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m292.5 241.6 285.8-.4-.5-47.8-301.5 2.3-.2 45.9z",
    fill: "#e9edfa"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m435.5 202v32.9l134.5-.5v-32z",
    fill: "#bac5f4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m291.7 202v32.9l134.5-.5v-32z",
    fill: "#bac5f4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m291.7 209.9h7.1v25.1l-7.1-.1z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m298.9 214.3h4.7l.2 20.6-5 .1z",
    fill: "#f5f5fc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m417.5 209.7h4.1v25.1l-4.1-.1z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m421.7 214.1h4.7l.2 20.6-5 .1z",
    fill: "#f5f5fc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m304 211.1h4.7l.2 23.8-5 .1z",
    fill: "#f5f5fc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m308.6 216.8 2.4-1.9 12.3 17.8-2.7 2.2z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 234.8h29.5l-.2-3.4-29.3.2z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m370.7 231.5h29.5l-.1-3.3-29.4.2z",
    fill: "#e9edfa"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m440.2 208.7h4.1l.1 26.4-4.2-.1z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m444.4 214.3h4.7l.2 20.6-4.9.1z",
    fill: "#f5f5fc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m561 209.6h4.1l.1 25h-4.2z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m565.1 213.6h4.9l.2 20.8-5 .1z",
    fill: "#f5f5fc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m556.3 215.7h4.7l.2 18.9-5 .1z",
    fill: "#f5f5fc"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m435.4 211.1h4.8l.1 23.9-4.9.1z",
    fill: "#f5f5fc"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m484.4 216.9 2.4-2 12.2 17.9-2.6 2.1z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m464.4 234.8h29.5l-.2-3.3-29.3.2z",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m462.8 231.7h29.4l-.1-3.3-29.3.2z",
    fill: "#e9edfa"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m578.1 190.9-.3-38.3h268l.6 91.6-268.1 2.2-.2-52",
    fill: "#e9edfa"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m387.2 168.7s-2.6-.9-2.8-1.5-1.1-4.3.6-4.3h14.6s2.4 3.9-.6 4.7-.4 2.4.4 2.4 2.8 0 3.2 1.1.4 23.6.4 23.6h-21.7v-21.9c0-1.3 1-2.3 2.3-2.4h.1c2.4 0 4.1-.6 3.5-1.7z",
    fill: "#e9edfa"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m384.6 177.4h15.2v9.4h-15.2z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m412 168.7s-2.6-.9-2.8-1.5-1.1-4.3.6-4.3h14.6s2.4 3.9-.6 4.7-.4 2.4.4 2.4 2.8 0 3.2 1.1.4 23.6.4 23.6h-21.7v-21.9c0-1.3 1-2.3 2.3-2.4h.1c2.5 0 4.2-.6 3.5-1.7z",
    fill: "#bac5f4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m409.4 177.4h15.2v9.4h-15.2z",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m437.6 168.4s-2.6-.9-2.8-1.5-1.1-4.3.6-4.3h14.6s2.4 3.9-.6 4.7-.4 2.4.4 2.4 2.8 0 3.2 1.1.4 23.6.4 23.6h-21.7v-21.9c0-1.3 1-2.3 2.3-2.4h.1c2.4 0 4.2-.6 3.5-1.7z",
    fill: "#e9edfa"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m435 177.1h15.2v9.4h-15.2z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m587.3 161.9h123.8v75.6h-123.8z",
    fill: "#bac5f4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.4,
    cy: 201.7,
    fill: "#bac5f4",
    r: 5.4
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m670 211.6s-2.6-.9-2.8-1.5-1.1-4.3.6-4.3h14.6s2.4 3.9-.6 4.7-.4 2.4.4 2.4 2.8 0 3.2 1.1.4 23.6.4 23.6h-21.7v-21.9c0-1.3 1-2.3 2.3-2.4h.1c2.4 0 4.1-.6 3.5-1.7z",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m667.3 220.3h15.2v9.4h-15.2z",
    fill: "#f5f5fc"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m840.6 602.6s6.3-34.1-26.8-52.4-34.6-18.1-41.1-20.1c-3.8-1.3-7.6 1.4-3.3 6.9s1.9 6.9 10.6 9.3 10 13 14.4 15.6c4.3 2.6 8.1 3.3 21.4 9.1 12.1 5.2 22.3 19.9 22.3 25.1s11.8 6.9 11.8 6.9z",
    fill: "url(#b)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m839.4 597.8s8.4-31.4-20.5-48.4-39.1-16.8-44.8-18.8c-3.3-1.2 5.7 2.9 9.5 7.9s2.8 3.9 9.6 7.7c7.9 4.3 11.1 8.6 15.8 9.4 6.7 1.3 4.7 8.3 16.3 13.5 10.5 4.8 11.8 17.5 11.8 22.3s10.3 6.4 10.3 6.4z",
    fill: "url(#c)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m868.6 593.2 3.3-3.1c1.6-1.4 3.5-2.5 5.6-3.1 10.2-2.7 42.4-12.8 55.7-37.1.1-.2 0-.5-.2-.6h-.1c-.1 0-.1-.1-.2-.1-4.4-.3-27.3-.7-57.9 25.4-.5.4-1.1 1-1.5 1.5-.8 1.1-2 2.9-2.6 3.9-.8 1.4.8 3.8-1.3 5.8s-6.8 7.3-6.8 7.3l3.8 2.8z",
    fill: "url(#d)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m851.1 591.2s8.8-78.5-15.2-103.2c-22.1-22.7-22.4-1.8-22.3 1.7 0 .3.1.6.2.9 5.2 9.7 7 20.9 5.1 31.7-2.3 11.4 14 9.9 15.4 21.1s7.1 28.4 6.5 36.4c-.6 7.9-.6 15.6-.6 15.6l8.8.3z",
    fill: "url(#e)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m851 591.5c.1-.2.1-.4.2-.5.5-5.1 7.9-79.1-15.2-103-21.9-22.6-22.2-2.1-22.1 1.6.1.4.3.9.5 1.2 1.6 2.4 8.8 12.6 15.3 11.5 17.7-3.2 2.1 18.2 11.7 29.6 7.7 9 5.1 40.1 4.6 48.1-.4 4.5-1.1 8.9-2.2 13.3-.2 1.1.5 2.2 1.6 2.4h.2c.2 0 .3.1.4.1h1.6c1 .1 1.8-.4 2.3-1.3z",
    fill: "url(#f)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m859.7 596s1.6-21.8 14.3-35c3.5-3.6 8-6.2 13-7.3 3.8-.9 10-3.9 15.4-14.1 0 0 10.2-14.5 20.5-18.9 10.2-4.4 0-4.9 0-4.9s-29.3 5.6-48 22.7c-1.2 1.1-2.4 2.1-3.8 2.9-4.9 3.3-18.3 15.9-17.7 52.4z",
    fill: "url(#g)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m885.1 594.3s.4-2.6-3.1-2.6c-3.1.1-54.7-.3-54.7-.3s-2.4 0-2.2 1.8 8 44.8 8.7 45.8c.3.5.9 1 1.5 1.1 1 .3 37.2.1 37.2.1.9-.1 1.5-.8 1.6-1.7-.1.1 11.1-43.7 11-44.2",
    fill: "url(#h)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m230.7 569.3-2.6-.1-13.3.1s-2.9 13.6-4.5 19.3c-.1.4-.4 1.3-.6 2-.2 1-.3 2-.3 3 .3 5.2 2.2 9.5 6.8 11.9 5 2.6 8.9 4.9 14.3 0s6.1-8 4-16.5c-1.9-8.6-2.6-19.4-3.8-19.7z",
    fill: "#4b44be"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 586.3c-9.2-2.9-15.3-15.3-15.3-15.3l-15.6-.9s-.9 12.6-1.3 19c-.6 8.5.9 12.3 6.5 11.9 7.4-.6 37.4 2.1 42.2-.9 6.1-4.1-8-11.1-16.5-13.8z",
    fill: "#4b44be"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m192.4 344.8v18.7l22.6 206h16s5.5-141.3 5.5-146.2 1.4-20.2 1.4-20.2 20.1 58 20.5 62.9c.4 4.8-3.3 104.8-3.3 104.8l16 .6s14-67.6 14-74 4.8-39.6 4-46c-.7-6.4-12.6-106-12.6-106l-24.5-.6z",
    fill: "url(#i)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m296.1 323.2-.2-.3c0 .2.1.4.2.3m-47-18.1-8.9 3.7-.5 12.4 9.9 3.9c0-.1 10.8-.4 10.8-.5.1-.5 4.3-.4 6.2.9l33.5-11.5 1.2-8s2.5 10.1-8.7-10.2zm40-40.8-.7-4-1.7-.3zm-61.9-107.6c-4.1 1.7-6.1 7.7-6.1 7.7s-2-1.2-2 2.2 1.7 11.1 2.9 13.1c2.1 3.3 4 6.7 5.8 10.3 1.6 3.6 1.1 10.8-.6 11.9s-32.1 28.3-32.1 28.3l-25.1 77v3.1l3.8 1.3 4 3.4c.4.1 5.4 2.8 6.1 3.3 4 2 8.2 3.5 12.6 4.5 2.8.6 15.4.3 15.4.3l12.7-.3-2.2-16.2-18.8-.2-25.7-1.3 26.1-59.9 82.2 14.7c-14.6-26.4-31-56.1-32.5-59.2-1.2-2.6.1-8.7.8-11.9.6-2.9 2.1-6.5 3.4-7.5s3.8-5.8 3.8-7.8.6-10.1-1.1-8.4c-.5.5-2.5-2.6-3.2-5.6-1.1-4.4-4.2-7.5-7.7-10.4 0 0-18.1 6-22.2 7.7",
    fill: "url(#j)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m195.8 213.7c-4 2.7-7.7 6.3-9 11s-10.9 41.2-12.2 45.8c-3.1 11.3-5 14.6-8.7 27.8-4.5 16.3 5.9 18.8 16.5 21.2 11.1 2.5 11.2 3.6 13.8 3.6.4 0 13.6 2.7 14-4.8.3-4.7-.6-12.1-2.3-11.9-4 .6-17.1-2.9-17.8-3.3-.9-.6 2.8-10.8 5-17.1 1.6-4.7 7.6-24.1 8.9-27.8.7-2-3.4 18.9-5.9 39.3-.1.8-1.1 8.7-.8 8.7 3 0 11.2.1 13.7.4 11.5 1.3 13.7 6.8 13 11.2-1.3 7.7-29.3 4.1-29.1 5.1 0 0-4.8 21.7-2.1 23.1 2.3 1.2 33.7 14.3 40.4 16.8.7.3 1.6-.1 1.8-.9 0 0 0 0 0-.1l4.3-12.2c.1-.1.2-.2.4-.1.1 0 .1.1.1.1l4 13.4c.1.4.4.6.6.8h1.8l34.9-7.5s-.1-13.8-.2-31.4c0-1.8-.3-8.3-1.6-7.1s-30.4 5-33.6 3.7c-6.7-2.8-5-9.9-2.6-12.8 2.7-3.3 37.1-5 37.2-7.5.6-10.8-.3-39.1-.9-35.7-.9 5.3-21 34.4-21 39.5s-.4 17.8-.4 17.8l33-2.6s11.1-3.8 12.1-10.2-.2-9.2-.6-18.8c-.3-6-8.8-42.3-11.2-52.6-.4-1.6-.6-3.1-.7-4.7-.3-4.3-2-14.2-11.2-18.5-11.4-5.4-20.2-9.7-22.5-9.7-2.1 0-8 12.8-11 16.4-1.3 1.6-1.1 2.4-2.8 4.8-.9 1.3-2.6 1.5-3.9.6-.3-.2-.5-.5-.7-.8-1-1.4-1.8-3-2.6-4.5-1.3-2.7-11.8-18.1-11.8-18.1s-24.3 6.8-28.3 9.6",
    fill: "url(#k)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m249.5 149.2s-22.3 8.3-23.9 9.5-4.5 5.8-4.5 5.8-1.6-.9-1.9 1.5c0 0-2.3-4.7-2.6-7.3s0-9.4 4.3-13.9 12.9-10.4 18.2-9.6 7.6 1.4 10.9 4.8c3.3 3.3 6.2 4.3 7.2 4.8s4.8 3.3 5.5 8.5c.6 5.2-1.1 15.6-1.1 15.6s.5-4-1.1-2.8c-1.1.9-2.8-2.8-3.3-5-.7-2.3-6.4-11.4-7.7-11.9z",
    fill: "url(#l)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257 206c-.1-.4 2.4 1.5-.6-.6-4.2-3.1-2.2-15.6-2.2-15.6-1.6 3.3-4.3 5.8-7.6 7.1-5.3 2-7 .5 1.3 5.3 8.1 4.7 3.9 6.3 3.3 12.5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m273.3 250.2 11.1 42s-.1 7.5-2.3 8.6-9.2 1.8-10.8 2.6-18.6 4.3-14.2-1.7c1-1.3 24-9.4 13.7-17.8s-8.5-20.2-3.5-28.3 3.9-15 3.9-15z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.4 360.8s-9.6 50.9-4.6 71.2c7.5 30.8-3.3 72.5-3.3 92.5 0 13 5.1 48.9 5.5 63.6.1 4.4 3.3 12.9.9 14.9-1 .9-7.1-1.1-10.4-2.7-1.8-.9-2.8-2.7-2.6-4.5l2-8.7 2.8-11.5-19.9-186.1s-6.4-41.4-2.8-41.6 32.5 12.9 32.4 12.9"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m217.3 292.4 37.6 4.7c.8.2 1.3.9 1.2 1.8l-1.1 34c-.1 1.1-.7 2.5-1.7 2.2l-37.4-7.2c-.7-.2-1.2-.9-1.2-1.6l-.1-3.7 4.1-1.1c1.1-.3 2.1-.9 2.9-1.5.2-.1.4-.3.5-.5l.9-1.3c.3-.4.4-.9.3-1.3-.1-.8-.4-1.8-.5-2.4-.1-.2-.1-.4-.2-.6l-.9-2c-.4-.9-1.1-1.6-2.1-2.1l-.6-.3-4-2.2.4-13.3c0-.9.8-1.6 1.7-1.6z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m528.4 354.5 83.5-3.5 12.4-58.2-84.8.7-12.7 60.9",
    fill: "url(#p)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.6,
    cy: 325.4,
    fill: "#fff",
    rx: 5.1,
    ry: 5.4
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m527.6 350.2-45.6-.1c-.3 0-.5.2-.6.5l-.6 2.7c-.1.3.1.6.5.7h.1l45.4.4c.3 0 .5-.2.6-.5l.8-3.1c.1-.3-.1-.6-.4-.7-.1.1-.1.1-.2.1z",
    fill: "url(#q)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m538.1 291.9 84.8-.6c.1 0 .2.1.3.2l1.1 1.3-84.5.7c-.2 0-.3.1-.4.3l-11 60.3c0 .2-.2.3-.4.3h-.7c-.2 0-.4-.2-.4-.4 0 0 0 0 0-.1l10.5-61.4c0-.3.3-.6.7-.6z",
    fill: "url(#r)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m685.6 323.7-5.8 32.9s7.5-1.3 11.1 0z",
    fill: "url(#t)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m685.6 323.7 5.3 32.9s22.3-2.8 39.4-.2l-6.1-32.6z",
    fill: "#fcfcfc"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#58caea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m707.8 340.4-5.4.1-.7-4.3h5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m716.4 340.2-5.4.1-.8-4.4h5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m724.5 340.2-5.4.1-.8-4.3h5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725.5 346.1-5.3.1-.8-4.4h5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m709 346-5.4.1-.8-4.3 5.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700.7 346.3-5.4.1-.8-4.4h5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702 352.3-5.4.1-.8-4.3h5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710.3 352.2-5.4.1-.8-4.3 5.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.8 352.2-5.4.1-.8-4.4h5.3z"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m717.5 346-5.4.1-.8-4.3 5.3-.1z",
    fill: "url(#u)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m685.6 323.7 1.5 9.4 38.9-.2-1.8-9.1z",
    fill: "url(#v)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m696.2 321.6 3-.1.3 4.2h-2.9z",
    fill: "url(#x)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m714.7 321.8 2.5-.1.3 3.9h-2.5z",
    fill: "url(#y)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m526.4 183.8h17.7c.2 0 .3.1.3.3s-.1.3-.3.3h-17.7c-.2 0-.3-.1-.3-.3 0-.1.1-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m526.4 184.9h17.7c.2 0 .3.1.3.3s-.1.3-.3.3h-17.7c-.2 0-.3-.1-.3-.3s.1-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m526.4 186h17.7c.2 0 .3.1.3.3s-.1.3-.3.3h-17.7c-.2 0-.3-.1-.3-.3s.1-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m530.4 189.4h16.1c.2 0 .3.1.3.3s-.1.3-.3.3h-16.1c-.2 0-.3-.1-.3-.3s.2-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m530.4 190.5h16.1c.2 0 .3.1.3.3s-.1.3-.3.3h-16.1c-.2 0-.3-.1-.3-.3s.2-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m530.4 191.5h16.1c.2 0 .3.1.3.3s-.1.3-.3.3h-16.1c-.2 0-.3-.1-.3-.3 0-.1.2-.3.3-.3z",
    fill: "#f4f4f4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m502.7 182.7s-2.4.2-2.4 2.6 2.5 2.5 2.5 2.5l42 .1v-.7h-18.8s-.6.1-.5-.8v-2.5c0-.3.2-.5.5-.6.8 0 18.4.2 18.4.2v-.9z",
    fill: "url(#A)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 183.7 18.2.1",
    fill: "none"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 184.2 18.2.1",
    fill: "none"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 184.7 18.2.1",
    fill: "none"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 185.1 18.2.1",
    fill: "none"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 185.7 18.2.1",
    fill: "none"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m525.7 186.3 18.2.1",
    fill: "none"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m504.4 187.8s-2.6.3-2.6 2.9c0 2.3 1.8 2.8 2.3 2.9h.2 42.8v-.9h-16.6s-1.1 0-.9-1.1v-2.2s-.1-.8.8-.8c.8 0 16.5.2 16.5.2v-1.1z",
    fill: "url(#C)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m530 189.2 15.8.1",
    fill: "none"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m530 189.7h15.8",
    fill: "none"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m530 190.1 15.8.1",
    fill: "none"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m530 190.6 15.8.1",
    fill: "none"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m530 191.2 15.8.1",
    fill: "none"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m530 191.8 15.8.1",
    fill: "none"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m530 192.3 15.8.1",
    fill: "none"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m528.6 183.8h1.4c.4.3.7.7.8 1.2.2.8 0 1.1.5 2 .3.6.6.9.8 1.3 0 .1.1.6.1.7l.1 1.4-.6-.4-.6.6s0-1.9-.2-2.3-1.2-1.7-1.1-2.6c.3-.9-.1-1.3-1.2-1.9z",
    fill: "#f8246a"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m551.7 157.8h3.2c.8 0 1.4.6 1.4 1.4v33.8c0 .8-.6 1.4-1.4 1.4h-3.2c-.8 0-1.4-.6-1.4-1.4v-33.8c0-.8.6-1.4 1.4-1.4z",
    fill: "url(#D)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m484.3 157.5h3.2c.8 0 1.4.6 1.4 1.4v33.8c0 .8-.6 1.4-1.4 1.4h-3.2c-.8 0-1.4-.6-1.4-1.4v-33.8c-.1-.7.6-1.4 1.4-1.4z",
    fill: "url(#E)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m563.1 172.3 2.3-1.3c.7-.4 1.6-.2 1.9.5l11.3 19.5c.4.7.2 1.6-.5 1.9l-2.3 1.3c-.7.4-1.6.2-1.9-.5l-11.3-19.5c-.4-.6-.2-1.5.5-1.9z",
    fill: "url(#F)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m557.7 163h3.2c.8 0 1.4.6 1.4 1.4v28.6c0 .8-.6 1.4-1.4 1.4h-3.2c-.8 0-1.4-.6-1.4-1.4v-28.6c0-.8.6-1.4 1.4-1.4z",
    fill: "url(#G)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m490.4 158.8h3.2c.8 0 1.4.6 1.4 1.4v32.5c0 .8-.6 1.4-1.4 1.4h-3.2c-.8 0-1.4-.6-1.4-1.4v-32.5c0-.7.6-1.4 1.4-1.4z",
    fill: "url(#H)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg62);
export default __webpack_public_path__ + "static/media/bg6-2.9f5d83acef46267a3022fea40e8530ea.svg";
export { ForwardRef as ReactComponent };